import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { PlannedDurationSettings } from '.'
import { APIResponse } from 'helpers'

export const putAppointmentPlannedDurationSettings = (data: PlannedDurationSettings) =>
  createAsyncApiAction<Blob>('gms', {
    method: 'PUT',
    url: `/modules/workorder-appointments/planned-duration/settings`,
    data
  })

export const getAppointmentPlannedDurationSettings = () =>
  createAsyncApiAction<APIResponse<PlannedDurationSettings>>('gms', {
    method: 'GET',
    url: `/modules/workorder-appointments/planned-duration/settings`
  })
